import React from "react"
import Button from "./button.web"
import EmailButton from "./button.email"

export default {
  component: Button,
  email: EmailButton,
  styles: () => (
    <outlook-only>
      <style>{`.button-table { padding: 12px 0 }`}</style>
    </outlook-only>
  ),
  schema: {
    nodes: [
      {
        match: [{ object: "text" }]
      }
    ]
  },
  commands: {
    insertButton: (editor, { href, text, ...data }) => {
      editor
        .insertBlock({ type: "button", data: { href, ...data } })
        .insertText(text)
    }
  },
  keymap: {
    enter: (event, editor, next) => {
      const focus = editor.value.selection.focus
      const startBlock = editor.value.startBlock

      const cursorAtStart = focus.offset === 0
      const cursorInMiddle =
        focus.offset > 0 && focus.offset < startBlock.text.length

      if (cursorAtStart) {
        const index = editor.value.document.nodes.indexOf(startBlock)
        editor.insertNodeByKey(editor.value.document.key, index, {
          object: "block",
          type: "paragraph"
        })

        return
      }
      if (cursorInMiddle) {
        editor.insertText("\n")
        return
      }
      next()
    }
  }
}
